export default __webpack_public_path__ + "static/media/101.4404dca3.jpeg";